const getters = {
	// size:state => state.user.size,
	name:state => state.user.name,
	token: state => state.user.token,
	avatar:state => state.user.avatar,
	userId:state => state.user.userId,
	courseId:state => state.user.courseId,
	gender:state => state.user.gender,
	phone:state => state.user.phone,
	navbarList:state=>state.navbarList
}
export default getters